import React from "react";
import { Box, Typography, Grid, Paper } from "@mui/material";
import { convertDateToCustomFormat } from "../../../utils/commonUtils";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";

// const salesData = [
//   { label: "Total Sale", today: "0.00", monthly: "77801.95" },
//   { label: "Counter Sale", today: "0.00", monthly: "77801.95" },
//   { label: "Credit Sale", today: "0.00", monthly: "0.00" },
//   { label: "Expenses", today: "0.00", monthly: "14000.00" },
//   { label: "Number of Bills", today: "0", monthly: "38" },
//   { label: "Product Sold", today: "0", monthly: "58" },
//   { label: "Service Sold", today: "0", monthly: "26" },
// ];

const TableReport = ({ salesData, colName, data }) => {
  return (
    <Box
      sx={{
        py: "20px",
        px: { xs: "10px", sm: "50px" },
        background: "white",
        borderRadius: "12px",
      }}
    >
      <Grid container spacing={1} sx={{}}>
        <Grid
          container
          spacing={1}
          sx={{
            borderBottom: "1px solid #1E1E1E",
            padding: "10px 0px",
            paddingRight: "15px",
          }}
        >
          <Grid item xs={3}>
            <Typography
              fontWeight={500}
              color="primary"
              sx={{
                textAlign: "center",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              Date
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography
              fontWeight={500}
              color="primary"
              sx={{
                textAlign: "center",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              CGST
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography
              fontWeight={500}
              color="primary"
              sx={{
                textAlign: "center",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              SGST
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography
              fontWeight={500}
              color="primary"
              sx={{
                textAlign: "center",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              IGST
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography
              fontWeight={500}
              color="primary"
              sx={{
                textAlign: "center",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              Total GST
            </Typography>
          </Grid>
        </Grid>

        {/* Header */}
        <Grid
          container
          mt={2}
          sx={{
            height: "50vh",
            overflow: "auto",
            marginTop: "10px",
            paddingRight: "10px",
          }}
        >
          <Grid item xs={12}>
            {data.map((item, idx) => (
              <Grid
                container
                key={idx}
                elevation={2}
                sx={{ borderRadius: "10px", my: "5px", background: "#E3E3FF" }}
              >
                <Grid item xs={3}>
                  <Box p={1}>
                    <Typography
                      fontWeight={500}
                      sx={{
                        textAlign: "center",
                        fontSize: { xs: "10px", sm: "13px", md: "15px" },
                      }}
                    >
                      {convertDateToCustomFormat(item?.billDate?.split("T")[0])}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={2} pl={{ xs: 0, sm: 1, md: 3, lg: 6 }}>
                  <Box
                    p={1}
                    sx={{
                      display: "flex",
                      // justifyContent: "center",
                      alignItems: "center",
                      // paddingLeft: "60px",
                    }}
                  >
                    <CurrencyRupeeIcon
                      color="#000000"
                      sx={{
                        // textOverflow: "ellipsis",
                        // fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        // paddingLeft: "7px",
                      }}
                    />
                    <Typography
                      color="#000000"
                      sx={{
                        textOverflow: "ellipsis",
                        fontWeight: 500,
                        paddingLeft: { sm: "7px", xs: "0px" },
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                    >
                      {item.cgstAmount?.toFixed(2)}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={2} pl={{ xs: 0, sm: 1, md: 3, lg: 6 }}>
                  <Box
                    p={1}
                    sx={{
                      display: "flex",
                      // justifyContent: "center",
                      alignItems: "center",
                      // paddingLeft: "60px",
                    }}
                  >
                    <CurrencyRupeeIcon
                      color="#000000"
                      sx={{
                        // textOverflow: "ellipsis",
                        // fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        // paddingLeft: "7px",
                      }}
                    />
                    <Typography
                      color="#000000"
                      sx={{
                        textOverflow: "ellipsis",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingLeft: { sm: "7px", xs: "0px" },
                      }}
                    >
                      {item.sgstAmount?.toFixed(2)}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={2} pl={{ xs: 0, sm: 1, md: 3, lg: 6 }}>
                  <Box
                    p={1}
                    sx={{
                      display: "flex",
                      // justifyContent: "center",
                      alignItems: "center",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      // paddingLeft: "60px",
                    }}
                  >
                    <CurrencyRupeeIcon color="#000000" fontSize="10px" />
                    <Typography
                      color="#000000"
                      sx={{
                        textOverflow: "ellipsis",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingLeft: { sm: "7px", xs: "0px" },
                      }}
                    >
                      {item.igstAmount?.toFixed(2)}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={3} pl={{ xs: 0, sm: 3, md: 5, lg: 12 }}>
                  <Box
                    p={1}
                    sx={{
                      display: "flex",
                      // justifyContent: "center",
                      alignItems: "center",
                      // paddingLeft: 15,
                    }}
                  >
                    <CurrencyRupeeIcon
                      color="#000000"
                      sx={{
                        // textOverflow: "ellipsis",
                        // fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        // paddingLeft: "7px",
                      }}
                    />
                    <Typography
                      color="#000000"
                      sx={{
                        textOverflow: "ellipsis",
                        fontWeight: 500,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        paddingLeft: { sm: "7px", xs: "0px" },
                      }}
                    >
                      {item.totalAmount?.toFixed(2)}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TableReport;
